<template>
    <ui-report title="HSQE Report" subtitle="View open defects, NCRs and accidents and their activity." :initial-filters="initialFilters" v-slot="{ filters }">
        <reports-hsqe-open-defects></reports-hsqe-open-defects>
        <reports-hsqe-open-ncrs></reports-hsqe-open-ncrs>
        <reports-hsqe-defects :filters="filters" :parse-report="parseReport"></reports-hsqe-defects>
        <reports-hsqe-accidents :filters="filters" :parse-report="parseReport"></reports-hsqe-accidents>
        <reports-hsqe-ncrs :filters="filters" :parse-report="parseReport"></reports-hsqe-ncrs>
    </ui-report>
</template>

<script>
import moment from 'moment'
import { flatMap } from 'lodash'

export default {
    data () {
        return {
            initialFilters: {
                range: 'since-monday',
            },
        }
    },
    methods: {
        parseReport (report, filters) {
            const from = moment(filters?.from)
            const to = moment(filters?.to)

            return flatMap(report, item => {
                if (item.closed_at && moment(item.opened_at).isBetween(from, to, 'days', '()')) {
                    const openedItem = item.clone()
                    openedItem.closed_at = null
                    return [openedItem, item]
                }

                return [item]
            })
        },
    },
}
</script>
